import { render } from "./AppFooter.vue?vue&type=template&id=580388b6&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=580388b6&scoped=true&lang=scss"

import exportComponent from "D:\\htdocs\\cosmocoslab_live\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580388b6"]])

export default __exports__